import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  valueBox: {
    flexBasis: "46%",
    position: "relative",
    "&:after": {
      content: "''",
      display: "block",
      paddingBottom: "100%",
    },
  },
  valueBoxSelected: {
    backgroundColor: theme.palette.custom.additional4,
    color: "#fff",
  },
  valueBoxContent: {
    left: "0",
    top: "0",
    bottom: "0",
    position: "absolute",
    padding: theme.spacing(2),
  },
  blueBoxTitle: {
    fontSize: "1.5rem",
    fontWeight: "bolder",
    color: "#14142A",
  },
  blueBoxTitleSelected: {
    color: "#FFF"
  },
  blueBoxText: {
    // fontSize: "1.1rem",
    minHeight: "80px",
  },
  mT: { marginTop: theme.spacing(1) },
  mB: { marginBottom: theme.spacing(1) },
  mR: { marginRight: theme.spacing(1) },
  mL: { marginLeft: theme.spacing(1) },
}));

const ValueProposal = ({
  values,
  pictoL,
  pictoD,
  selected,
  onMouseEnter,
  mT,
  mB,
  mL,
  mR,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("lg"));
  return (
    <div
      onMouseEnter={onMouseEnter}
      className={clsx(classes.valueBox, {
        [classes.valueBoxSelected]: selected,
        [classes.mR]: mR,
        [classes.mL]: mL,
        [classes.mB]: mB,
        [classes.mT]: mT,
      })}
    >
      <div className={classes.valueBoxContent}>
        <Grid
          container
          direction="row"
          justify="space-between"
          style={{ height: "100%" }}
        >
          <Grid item xs={12}>
            <div style={{ width: "50%" }}>
              <img src={selected ? pictoL : pictoD} alt="picto" width="45%" />
            </div>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              className={clsx(
                { [classes.blueBoxTitleSelected]: selected },
                classes.blueBoxTitle
              )}
            >
              {values.title}
            </Typography>
            <Typography variant="body1" className={classes.blueBoxText}>
              {values.content}
            </Typography>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

ValueProposal.defaultProps = {
  mT: false,
  mB: false,
  mL: false,
  mR: false,
};

ValueProposal.propTypes = {
  values: PropTypes.object.isRequired,
  pictoD: PropTypes.string.isRequired,
  pictoL: PropTypes.string.isRequired,
  mT: PropTypes.bool.isRequired,
  mL: PropTypes.bool.isRequired,
  mR: PropTypes.bool.isRequired,
  mB: PropTypes.bool.isRequired,
  selected: PropTypes.bool.isRequired,
  onMouseEnter: PropTypes.any,
};

export default ValueProposal;
